// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"e4908f2f","453":"4120b2f3"}[chunkId] + ".chunk.js";
};